import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthModalClose, setIsAuthQuestionModalClose } from '../../redux/reducer/slices/profileSlice';
import { setHeaderHeight } from "../../redux/reducer/slices/commonSlice";
import { setIsAddressModalClose } from "../../redux/reducer/slices/companiesSlice";
import { Wrapper, Content } from '../styles';
import { Message } from "../../components/Message";
import Modal from "../../components/Modal";
import AuthForm from "../../containers/forms/authForm/AuthForm";
import AddressSelectorForm from "../../containers/forms/addressSelectorForm/AddressSelectorForm";
import AuthQuestionForm from "../../containers/forms/authForm/AuthQuestionForm";
import { setGeocodeAddress, setGeocodeCoords } from "../../redux/reducer/slices/mapSlice";
import { useScroll } from "../../hooks/ScrollContext";
import Header from "../../containers/header/Header";
import Footer from "../../containers/footer/Footer";

const excludedHeaderPages = ['/app', '/price', '/delivery', '/kitchens', '/testdrive', '/organizations', '/orderinfo'];
const excludedFooterPages = ['/app', '/delivery', '/kitchens', '/testdrive', '/organizations', '/orderinfo'];

const PartnerLayout = ({ children }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { device, headerHeight } = useSelector((state) => state.common);
    const { isAuthModalOpen, isAuthQuestionModalOpen } = useSelector((state) => state.profile);
    const { isAddressModalOpen, saveCompanyStatus } = useSelector((state) => state.companies);
    const { wrapperRef } = useScroll();

    const haveHeader = !excludedHeaderPages.includes(location.pathname);
    const haveFooter = (!excludedFooterPages.includes(location.pathname) && device === 'desktop') || (location.pathname === '/' && device === 'mobile');
    
    useEffect(() => {
        if (!haveHeader) {
            dispatch(setHeaderHeight(0));
        }
    }, [haveHeader]);

    // Сбрасываем скролл на всех страницах кроме главной
    useEffect(() => {
        if (wrapperRef.current) {
            wrapperRef.current.scrollTo(0, 0);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (saveCompanyStatus === 'fulfilled') {
            dispatch(setIsAddressModalClose());
        }
    }, [saveCompanyStatus]);

    return (
        <>
            <Wrapper ref={wrapperRef}>
                {haveHeader && <Header/>}

                <Content style={{ paddingTop: `${headerHeight}px` }}>
                    {children}
                </Content>

                {haveFooter && <Footer/>}
            </Wrapper>

            <Modal isOpen={isAuthModalOpen} onClose={() => {dispatch(setIsAuthModalClose())}}><AuthForm/></Modal>
            <Modal isOpen={isAddressModalOpen} onClose={() => {dispatch(setIsAddressModalClose()); dispatch(setGeocodeAddress(null)); dispatch(setGeocodeCoords(null));}}><AddressSelectorForm/></Modal>
            <Modal isOpen={isAuthQuestionModalOpen} onClose={() => {dispatch(setIsAuthQuestionModalClose())}}><AuthQuestionForm/></Modal>

            <Message/>
        </>
    );
};

export default PartnerLayout;
